export const externalAppType =
{
  zabka: 0,
  light: 1
}